/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchSnippetDataParser = /* #__PURE__ */ parsers.object([
    ['key', codecString],
    ['value', codecString],
]);
export class PatchSnippetData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSnippetDataParser.decode(input).map(res => new PatchSnippetData(res));
    }
    static unsafeDecode(input) {
        return PatchSnippetData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSnippetDataParser.encode(data);
    }
    static schema() {
        return PatchSnippetDataParser.schema();
    }
}
